export const ROLES = {
  SUPER_ADMIN: 1, //캐어유 슈퍼 어드민
  ASSOCIATION_ADMIN: 2, // 협회 어드민
  ORG_ADMIN: 3, // 기관 어드민
  ORG_COUNSELOR: 4, // 기관 상담사
  PERSONAL_USER: 5, // 개인 회원
}

export const ROLES_STRING = [
  '캐어유 관리자',
  '협회 관리자',
  '기관 관리자',
  '기관 상담사',
  '개인회원'
];

export const USER_STATUS = {
  WAITING_FOR_REVIEW: 0, // 리뷰 대기
  IN_REVIEW: 1, // 리뷰중
  REJECTED: 2, // 거부
  READY: 3, // 승인됨
  REMOVED: 4, // 제거됨
}

export const USER_STATUS_STRING = [
  '심사대기',
  '심사중',
  '거부됨',
  '승인완료',
  '제거됨'
]

export const ROLE_STATUS = {
  WAITING_FOR_REVIEW: 0, // 리뷰 대기
  IN_REVIEW: 1, // 리뷰중
  REJECTED: 2, // 거부
  READY: 3, // 승인됨
  REMOVED: 4, // 제거됨
}

export const ROLE_STATUS_STRING = [
  '심사대기',
  '심사중',
  '거부',
  '승인',
  '제거',
]

